/**
 * Browser entry point. Wires the DOM to the application shell and kicks off the
 * Pyodide boot sequence. Kept tiny on purpose — all real logic lives in
 * `ui/app.ts` and `pyodide/*` so it can be unit-tested without a DOM.
 */
import "./style.css";
import { boot, queryAppElements, setPhase } from "./ui/app";

async function main(): Promise<void> {
  const els = queryAppElements(document);
  try {
    await boot(els);
  } catch (error) {
    console.error("Sprocket failed to start:", error);
    setPhase(
      els,
      "error",
      "Uh oh — the robot brain wouldn't start. Check the console and refresh.",
    );
  }
}

main();
